export enum FeedbackSurveyCategory {
  Knowledge = 1,
  Professionalism = 2,
  ResolutionTime = 3,
  FollowUp = 4,
  ProductQuality = 5,
  Other = 999,
};

export enum ExtensionAttributeKeys {
  IsAAD = 'IsAAD',
  UserObjectId = 'UserObjectId',
  Theme = 'Theme',
  AimId = 'AimId',
  AppName = 'AppName',
  BucketId = 'BucketId',
  IsMmdUser = 'IsMmdUser',
  ThemeL1 = 'ThemeL1',
  ThemeL2 = 'ThemeL2',
  ThemeL3 = 'ThemeL3',
  TimezoneOffsetInMinutes = 'TimezoneOffsetInMinutes',
  WaitTime = 'WaitTime',
  IsEdu = 'IsEdu',
  IsoCallingCode = 'IsoCallingCode',
  PremierEntitlementId = 'PremierEntitlementId',
  IsPremierUnified = 'IsPremierUnified',
  IsUnifiedEnterprise = 'IsUnifiedEnterprise',
  OmnichannelReconnectId = 'OmnichannelReconnectId'
};

export enum RequestModality {
  // To handle undefined modality because it can be optional.
  // Note that this does not map with Rave model and we should not send it to Rave.
  Undefined = 0,
  // The Freelance Partner is required to immediately create a Session and call the customer.
  Phone = 1,
  // The Freelance Partner can contact the customer via email.
  Email = 2,
  // The Request came from the IVR system.
  IVR = 3,
  // The Freelance Partner can contact the customer via chat only
  Chat = 4,
  // The Request came from the IVR C2C.
  C2C = 5
};

export enum RequestSeverity {
  // Non critical issue used by unified premier tenants
  // Means non critical issues
  None = 0,
  // Critical issue used by unified premier tenants
  // Means critical issues
  Critical = 1,
  // Changed it to Sev1 to align with Support Central
  // Critical issue used by unified premier tenants
  // Means critical issues
  Sev1 = 2,
  // Critical issue SevA used by non unified premier tenants
  // Means critical issues
  SevA = 3,
  // Non Critical issue SevB used by non unified premier tenants
  // Means non critical issues
  SevB = 4,
  // Non Critical issue SevC used by non unified premier tenants
  // Means non critical issues with longer SLA
  SevC = 5
};

// MetaData type, using Pascal case for Key/Value to align with Rave
export type MetaData =  {
  Key: string,
  Value: string
};

export class AttachmentData{
  public CwsId: string;
  public Name: string;
  public CreateDateTime: string;
  public ContentLocation: string;
  public ContentType: string;
  public Size: number;
  public RequestId: string;
  public WorkspaceId: string;
  public TenantId: string;
  public Location: string;
};

export class CustomerContact {
  public PrimaryContact:boolean;
  public Email: string;
  public PhoneNumber: string;
  public DialingCode: string;
};

export class Note {
  public Time: string;
  public Text: string;
};

export enum CommunicationRequestType {
  // cws Request number
  Cws = 0,
  // Parature Request number
  Parature = 1,
  // MSSupport Request number
  MSSupportTicket = 2,
  // CritSit Request number.
  CritSit = 3,
  // MS Solve Request number.
  MSaaS = 4,
  // MSaaS Premier Request number.
  MSaaSPremier = 5,
  // MSaaS CAICollaboration Ticket type.
  MSaaSCAICollaboration = 6,
  // Snow Ticket type.
  Snow = 7,
};

export class ServiceRequest {
  public RequestId: string;
  public WorkspaceId: string;
  public State: string;
  public MSSolveTicketNumber: string = String()
  public IsFeedbackClosed = false;
  public CreateDateTime: string;
  public NotifiedDateTime: string;
  public AcknowledgeDateTime: string;
  public CanceledDateTime: string;
  public ClosedDateTime: string;
  public CompletedDateTime: string;
  public CustomerFeedbackDateTime: string;
  public SurveyCategories: FeedbackSurveyCategory[] = [];
  public ServiceClosedDateTime: string;
  public PartnerId: string;
  public SupportAreaId: string;
  public SupportAreaName: string;
  public SupportAreaStepName: string;
  public UserPuid: string;
  public TenantId: string;
  public UserFirstName: string;
  public UserLastName: string;
  public UserPhone: string;
  public UserPhoneDialingCodeIndex: string;
  public UserCountryDialingCode: string;
  public UserPhoneWithoutDialingCode: string;
  public TwoDigitCountryCode: string;
  public UserEmail: string;
  public UserLcid: number;
  public SessionUrl: string;
  public SessionType: string;
  public SessionId: string;
  public PhoneNumber: string;
  public PhonePasscode: string;
  public IsDelegated: string;
  // MS Support Ticket
  public MSSupportTicket: string;
  public IsResolved: string;
  public Rating: string;
  public Comment: string;
  public ExtensionAttributes: { [key: string]: string };
  public RowVersion: string;
  public Source: string;
  public Modality: RequestModality;
  public ParatureTicketNumber: string;
  public Title: string;
  public UserDescription: string;
  public Severity?: RequestSeverity;
  public ReopenReason: string;
  public MetaDatas: MetaData[];
  public Attachments: AttachmentData[];
  public CustomerContacts: CustomerContact[];
  public Notes: Note[];
  public SecondaryTicketNumber?: string;
  public SecondaryTicketType?: CommunicationRequestType;
};